import { useEffect, useState } from 'react';
import { searchService } from '../services/search';
import { useTenantConfig } from '../contexts';
import { BannerEntity } from '../types';

export const useBanners = (zone: string) => {
  const [banners, setBanners] = useState<BannerEntity[]>([]);
  const [loading, setLoading] = useState(false);
  const { terminal } = useTenantConfig();

  useEffect(() => {
    if (!!zone && !!terminal) {
      setLoading(true);
      searchService.getBannerByZone(zone, terminal).then((_banners) => {
        setBanners(_banners);
        setLoading(false);
      });
    }
  }, [zone, terminal]);

  return {
    banners,
    loading,
  };
};
